export default {
  views: {
    list: {
      header: {
        title: "Zaloga kljuk",
        search_placeholder: "Poišči kljuke po kodi ..."
      },
      table: {
        code: "Koda",
        stock: "Zaloga"
      }
    }
  }
}
